import React from 'react';
import QRCode from 'react-qr-code';
import { useDeviceSelectors } from 'react-device-detect';
import { TranslationProvider, useTranslationContext, withProviders, } from '@resurs/hephaestus';
import styles from './AppWidget.module.scss';
import { Button, ButtonSize, ButtonType } from '../index';
import { da, fi, nb, sv } from './l10n';
const OperatingSystem = Object.freeze({
    ANDROID: 'ANDROID',
    IOS: 'IOS',
    HUAWEI: 'HUAWEI',
    NOT_SUPPORTED: 'NOT_SUPPORTED',
});
const { HUAWEI, NOT_SUPPORTED } = OperatingSystem;
const AppLinks = Object.freeze({
    HUAWEI: 'https://appgallery.huawei.com/app/C104609525',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.resurs.rbapp',
    IOS: 'https://apps.apple.com/app/resurs-bank/id1530346386',
});
const getAppLink = (operatingSystem) => AppLinks[operatingSystem] || NOT_SUPPORTED;
const useSelector = () => useDeviceSelectors(window.navigator.userAgent)[0];
const useDownloadInformation = () => {
    const { isMobile, isTablet, osName, mobileVendor } = useSelector();
    const isHuawei = mobileVendor.toUpperCase() === HUAWEI;
    const downloadLink = getAppLink(isHuawei ? HUAWEI : osName.toUpperCase());
    const isMobileOrTablet = isMobile || isTablet;
    const isAppSupportedOnDevice = isMobileOrTablet && downloadLink !== NOT_SUPPORTED;
    return [isAppSupportedOnDevice, isMobileOrTablet, downloadLink];
};
const AppWidget = () => {
    const [isAppSupportedOnDevice, isMobileOrTablet, downloadLink] = useDownloadInformation();
    const { getText } = useTranslationContext();
    if (!isAppSupportedOnDevice) {
        return null;
    }
    const downloadApp = () => window.open(downloadLink, '_blank');
    return (React.createElement("div", { className: styles.outerWidget, style: { maxWidth: isMobileOrTablet ? '343px' : '558px' } },
        React.createElement("div", { className: styles.innerWidget },
            React.createElement("div", { className: styles.contentWidget },
                React.createElement("div", { className: styles.appInfoRow },
                    React.createElement("div", { className: styles.appIconAndTextContainer },
                        React.createElement("div", { className: styles.appIcon }),
                        React.createElement("div", null,
                            React.createElement("p", null, getText('title')),
                            React.createElement("small", null, getText('costInformation')))),
                    isMobileOrTablet && (React.createElement(Button, { id: "download", size: ButtonSize.Small, type: ButtonType.CallToAction, onClick: downloadApp },
                        React.createElement("small", null, getText('download'))))),
                React.createElement("small", null, getText('description'))),
            !isMobileOrTablet && (React.createElement("div", { className: styles.qrCodeWrapper },
                React.createElement(QRCode, { "data-testid": "QrCodeAppWidget", value: downloadLink, bgColor: "white", size: 112 }))))));
};
export default withProviders([
    TranslationProvider,
    {
        translations: {
            sv,
            da,
            nb,
            fi,
        },
    },
])(AppWidget);
